import { useContext } from 'react';

import { CommandPaletteCreateActionFn } from '../commandPalette.types';
import {
  CommandPaletteContext,
  CommandPaletteContextValue,
} from '../commandPaletteContext';
import { createCommandPaletteAction } from '../createCommandPaletteAction/createCommandPaletteAction';

type UseCommandPaletteResult = CommandPaletteContextValue & {
  /** The function for creating an action. */
  readonly createAction: CommandPaletteCreateActionFn;
};

export const useCommandPalette = (): UseCommandPaletteResult => {
  const context = useContext(CommandPaletteContext);

  return {
    ...context,
    createAction: createCommandPaletteAction,
  };
};
